import React from "react";
import DynamicTable from "../../../../../../utils/Table/DynamicTable";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  setSummaryButton,
  setSummaryDetails,
  setViewSummaryDrawer,
} from "../../../../../../slices/viewSummarySlice";
import { truncateArray, truncateText } from "../../../../../../utils/function";
export default function TabSection({ pageData, setSelected, searchText }) {
  const dispatch = useDispatch();
  const columns = [
    {
      id: "title",
      label: "TITLE",
      width: "225px",
      filterable: true,
    },
    {
      id: "viewCounts",
      label: "VIEW COUNT",
      width: "225px",
      filterable: true,
    },

    { id: "likes", label: "LIKES COUNT", width: "225px", filterable: true },
    { id: "language", label: "LANGUAGE", width: "225px", filterable: true },
    { id: "subject", label: "SUBJECTS", width: "225px", filterable: true },
    { id: "summary", label: "SUMMARY", width: "225px", filterable: true },
  ];

  const transformedRows = (pageData || [])?.map((row) => {
    // Handle language array of objects

    return {
      ...row,
      likes: row?.likeCount ?? 0,
      viewCounts: row?.viewCount ?? 0,
      language: row?.language, // This will be the string of joined language names
      subject: truncateArray(row?.subject),
      summary: truncateText(row?.summary, 100),
    };
  });
  const handleRow = (row) => {
    dispatch(setViewSummaryDrawer(true));
    dispatch(setSummaryDetails(row));
    dispatch(setSummaryButton(true));
    setSelected(row);
  };

  return (
    <Box sx={{ height: "100%", paddingBottom: "16px" }}>
      <DynamicTable
        columns={columns}
        rows={transformedRows}
        searchText={searchText}
        onRowClick={(row) => {
          handleRow(row);
        }}
        key={transformedRows?.length}
        rowsPerPage={20}
      />
    </Box>
  );
}
TabSection.propTypes = {
  pageData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      viewCounts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      likes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      language: PropTypes.string,
      subject: PropTypes.string,
      description: PropTypes.string,
    })
  ), // Optional array of objects with the specified shape
  setSelected: PropTypes.func, // Required function to handle row selection
};
